// Footer.jsx

import React from "react";
import {
  FaFacebookF,
  FaWhatsapp,
  FaInstagram,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";

import "../style/Footer.scss";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* LEFT */}
        <div className="footer-column">
          <div className="footer-logo">
            <img src="/logo/logo evas.png" alt="" />
            <h2>Evas agency</h2>
          </div>

          <p className="footer-description">
            Your trusted partner for innovative and high-performance digital
            solutions.
          </p>

          <div className="social-icons">
            

            <a href="https://wa.me/+212690740001">
              <FaWhatsapp />
            </a>
            {/*
            <a href="https://wa.me/+212709638198">
              <FaWhatsapp />
            </a>*/}
            <a href="https://www.facebook.com/profile.php?id=61579697224640">
              <FaFacebookF />
            </a>

            <a href="https://www.instagram.com/evas.agence/">
              <FaInstagram />
            </a>


          </div>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-column">
          <h3>Quick Links</h3>

          <ul>
            <li>
              <a href="/">Home</a>
            </li>

            <li>
              <a href="/services">Services</a>
            </li>

            <li>
              <a href="/Showcase">Projects</a>
            </li>

            <li>
              <a href="/AboutUs">About</a>
            </li>

            <li>
              <a href="/contact">Contact</a>
            </li>
          </ul>
        </div>

        {/* SERVICES */}
        <div className="footer-column">
          <h3>Services</h3>

          <ul>
            <li>Web Development</li>
            <li>UI/UX Design</li>
            <li>Graphic Design</li>
            <li>Digital Marketing</li>
            <li>Content Writing</li>
          </ul>
        </div>

        {/* CONTACT */}
        <div className="footer-column">
          <h3>Contact</h3>

          <div className="contact-item">
            <FaEnvelope />
            <span>contact@evas-agency.com</span>
          </div>

           <div className="contact-item">
            <FaWhatsapp />
            <span>+212690740001</span>
          </div>
           {/*<div className="contact-item">
            <FaWhatsapp />
            <span> +212709638198</span>
          </div>*/}



          <div className="contact-item">
            <FaInstagram />
            <span>@evas.agence</span>
          </div>

          

          <div className="contact-item">
            <FaFacebookF />
            <span>Evas Agency</span>
          </div>
        </div>
      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        <p>2026 Evas Agency. All rights reserved.</p>

        <div className="footer-bottom-links">
          <a href="/">Privacy Policy</a>
          <a href="/">Terms of Use</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;